import Vue from 'vue';
import VueRouter from 'vue-router';
// import authService from '@/providers/authService';
import AppConstants from '@/appConstants';
import browserInfoHelper from '@/helpers/browser-info-helper';
import admin from './admin';
import auth from './auth';
import pages from './pages';
import news from './news';
import store from '@/store';
import authService from '@/providers/authService';
import VueI18n from '@/libs/i18n/index';
import Axios from 'axios';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import localStorageHelper from '@/helpers/local-storage-helper';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: '/news/manage'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    ...admin,
    ...auth,
    ...pages,
    ...news,
    {
      path: '/version',
      name: 'version',
      component: () => import('@/views/Version.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

// function hasQueryParams(route) {
//   return !!Object.keys(route.query).length
// }

router.beforeEach((to, from, next) => {
  // console.log('isAuthenticated', store.state.auth.isAuthenticated);
  // const isAuth = store.state.auth.isAuthenticated;
  // if (!isAuth) {
  //   return next();
  // }
  if (
    store.state.auth.isAuthenticated ||
    isPublicPage(to.path)
  ) {

    // if (to.path === AppConstants.NAVIGATION_PAGE_HOME) {
    //   router.push({ path: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/0` });
    //   return;
    // }

    // router.push({ path: `${AppConstants.NAVIGATION_PAGE_HOME}` });
    // if (to.name == from.name) {
    //   if(!hasQueryParams(to) && hasQueryParams(from)){
    //     return next({name: to.name, query: from.query});
    //   } 
    // } 
    return next();
    // return next({name: 'home'});
  }

  router.push({ path: AppConstants.NAVIGATION_PAGE_LOGIN, query: { to: to.path } });
  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  // auth.login({ target: to.path });

  if (browserInfoHelper.isBrowserIE()) {
    router.push({ path: AppConstants.NAVIGATION_PAGE_BROWSER_NOT_SUPPORT });
    return next();
  }
});

function isPublicPage(path) {
  if (path === AppConstants.NAVIGATION_PAGE_LOGIN ||
    path === AppConstants.NAVIGATION_PAGE_FORGOT_PASSWORD ||
    path === AppConstants.NAVIGATION_PAGE_RESET_PASSWORD ||
    path === AppConstants.NAVIGATION_PAGE_VERSION) {
    return true;
  }
  return false;
}

// --------- INTERCEPTORS ----------------

Axios.interceptors.request.use(
  request => {
    // add token
    // request.headers = { Authorization: 'token' };
    // add params
    // request.params = { teste: 'aaaa' };
    // console.log('interceptor request');
    let params = request.params;
    let emptyHeaders = false;

    // Initialize params if not exists
    if (!params) {
      params = new URLSearchParams();
    }

    if (store.state.auth.isAuthenticated) {
      request.headers = { Authorization: `Bearer ${store.state.auth.currentUser.token}` };
      if (request.url.includes('www.googleapis.com/youtube')) {
        emptyHeaders = true;
      }
      // params.append(AppConstants.PARAMS_TOKEN, store.state.auth.currentUser.token);
    }

    if (!params.get('lang')) {
      params.append('lang', VueI18n.locale);
    }
    request.params = params;
    request.headers['visitorId'] = localStorageHelper.getVisitorId();

    if (emptyHeaders) {
      request.headers = {};
    }

    return request;
  },
  err => {
    console.log('error request-> ', err);
  });

Axios.interceptors.response.use(
  response => {
    // console.log('interceptor response');
    return response;
  },
  error => {
    // console.log('error response-> ', error.response);
    if (!error.response) {
      return Promise.reject(error);
    }
    if (error.response.data.errorType == 'sendNews') {
      messagesNotifyHelper.handleErrorSendNews(error.response.data.errors);
      return Promise.reject(error.response.data.errors);
    }

    switch (error.response.status) {
      case 400:
        messagesNotifyHelper.handleError(error.response.data);
        break;
      case 401: // Unauthorized
        if (store.state.auth.isAuthenticated) {
          authService.logout();
          messagesNotifyHelper.sessionExpiredNotify();
        }
        break;
      case 403: // Forbidden - Access Denied
        if (error.request.responseType === 'arraybuffer') {
          var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
          var message = JSON.parse(decodedString);
          // console.log('403 message obj =>', message)
          messagesNotifyHelper.handleError(message);
          return;
        }
        messagesNotifyHelper.handleError(error.response.data);
        // messagesNotifyHelper.warningNotify('403', 'Forbidden - Access Denied');
        break;
      case 500:
        messagesNotifyHelper.operationErrorNotify('500');
        break;
      case 503: // Internal Server Error
        messagesNotifyHelper.serverUnavailableNotify();
        break;
      case 413: // Request entity too large
        messagesNotifyHelper.fileTooLargeNotify();
        break;
      default: // Other Error

        break;
    }
    // console.log(error.response.data);
    return Promise.reject(error.response.data);
    // return Promise(reject =>reject(error.response.data));
  });

export default router;
